/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Label, CardHeader, FormGroup, Input, CardBody, CardText, Card, Form, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Alert from 'react-s-alert';
// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const ClaimCounsellorProfileRequests = props => {
    // variables
    let timeout = 0;

    //stats
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState({ isVisible: false, data: {} });
    const [pagination, setPagination] = useState({ limit: 10, page: 1, searchVal: "" });
    const [requestsData, setRequestsData] = useState([]);

    // contexts
    const { theme } = useContext(ThemeContext);

    // useEffects
    useEffect(() => {
        getProfileRequests();
    }, [pagination.page, pagination.limit, pagination.search]);

    const getProfileRequests = () => {
        if (!isLoading) {
            setIsLoading(true);
            AdminService.getProfileRequests(pagination.limit, pagination.page, pagination.search, '').then(data => {
                try {
                    setRequestsData(data.claimProviderProfileRequests);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // GeneralService.logError('at Admin Clients useEffect', 'Error in try catch block', err.stack);
                    setIsLoading(false);
                }
            });
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setModal({ ...modal, data: { ...modal.data, [e.target.name]: e.target.value } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Coupons handleChange', 'Error in try catch block', err.stack);
        }
    }

    const openModal = (index) => {
        try {
            setModal({
                isVisible: true, data: {
                    title: "",
                    firstName: requestsData[index].requesterFirstName,
                    lastName: requestsData[index].requesterLastName,
                    email: requestsData[index].requesterEmail,
                    profileUniqueId: requestsData[index].profileUniqueId,
                    password: ""
                }
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Admin Clients showDetails', 'Error in try catch block', err.stack);
        }
    };

    const assignCounsellor = (e) => {
        try {
            e.preventDefault();
            AdminService.assignCounsellor(modal.data).then(data => {
                setModal({ isVisible: false, data: {} });
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                // getProfileRequests();
                setIsLoading(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
            })
        } catch (err) {
            console.log(err);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            //GeneralService.logError('at Admin Clients handleToggleChange', 'Error in try catch block', err.stack);
        }
    };

    const handleSearch = e => {
        try {
            let value = e.target.value;
            // if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, search: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }

    return (
        <main>
            <div className='container-fluid'>
                <h3 className='my-4'>Claim Counsellor Profile Requests</h3>
                <div className="card mb-4">
                    <div className="card-header d-flex">
                        <label className="my-auto">Requests</label>
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="7" className="border-0 px-0">
                                            <div className="d-flex">
                                                <div className="ml-auto">
                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, search: "" }); }}><i className="fa fa-times"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Profile Link</th>
                                        <th>Requester's Name</th>
                                        <th>Requester's Email</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        requestsData.map((item, index) => (
                                            <tr key={index}>
                                                <td className='profileLink'><a style={{ textDecoration: "underline", color: "#007bff" }} target='_blank' href={"https://www.umangwellness.com/counsellors/unclaimedProfile/" + item.profileUniqueId}>{"https://www.umangwellness.com/counsellors/unclaimedProfile/" + item.profileUniqueId}</a></td>
                                                <td className='requestersName'>{item.requesterFirstName} {item.requesterLastName}</td>
                                                <td className='requestersEmail'>{item.requesterEmail}</td>
                                                <td>{item.requestStatus === "pending" ? <Button onClick={() => openModal(index)} style={Object.assign({ height: 'fit-content' }, theme.formButton)}>Assign</Button> : item.profileStatus}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="7" className="border-0 pb-0 px-0">
                                            <div className="d-flex">
                                                <ErrorBoundary errorAt="At Admin Claim Counsellor Profile Requests Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    {/* <ErrorBoundary errorAt="At admin claim profile requests">      */}
                    <Modal isOpen={modal.isVisible} backdrop={true}>
                        <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, data: {} })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Assign Counsellor</span></ModalHeader>
                        <ModalBody>
                            <Card className="custom--card">
                                <CardHeader>Assign Counsellor to a Profile</CardHeader>
                                <CardBody>
                                    <CardText>
                                        Review the Counsellor details to be associated with the given
                                        Profile. The counsellor will be notified with the given
                                        credentials through automated email service
                                    </CardText>
                                    <Form onSubmit={assignCounsellor}>
                                        <FormGroup className="mb-3">
                                            <Label>Profile</Label>
                                            <p><a style={{ textDecoration: "underline", color: "#007bff" }} target='_blank' href={"https://www.umangwellness.com/counsellors/unclaimedProfile/" + modal.data.profileUniqueId}>{"https://www.umangwellness.com/counsellors/unclaimedProfile/" + modal.data.profileUniqueId}</a></p>
                                        </FormGroup>

                                        <FormGroup className="mb-3">
                                            <Label>First Name</Label>
                                            <Input type="text" name="firstName" value={modal.data.firstName} onChange={handleChange} />
                                        </FormGroup>

                                        <FormGroup className="mb-3">
                                            <Label>Last Name</Label>
                                            <Input type="text" name="lastName" value={modal.data.lastName} onChange={handleChange} />
                                        </FormGroup>
                                        <FormGroup className="mb-3" controlId="formBasicEmail">
                                            <Label>Counsellor Email</Label>
                                            <Input type="email" name="email" value={modal.data.email} onChange={handleChange} />
                                        </FormGroup>

                                        <FormGroup className="mb-3">
                                            <Label>Role</Label>
                                            <Input type="text" value="Counsellor" disabled />
                                        </FormGroup>
                                        <FormGroup className="mb-3">
                                            <Label>Initial Password</Label>
                                            <Input type="password" name="password" value={modal.data.password} onChange={handleChange} />
                                        </FormGroup>
                                        <Button type="submit" style={Object.assign({ height: 'fit-content' }, theme.formButton)}>
                                            Assign Counsellor
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </ModalBody>
                    </Modal>
                    {/* </ErrorBoundary>  */}
                </div>
            </div>
        </main>
    );
}

export default ClaimCounsellorProfileRequests;